import memoize from 'lru-memoize'
import { createValidator, email, required } from 'utility/validation'

const LoginFormValidation = createValidator({
  email: [required, email],
  password: [required],
})

export default memoize(10)(LoginFormValidation)
